<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-sc">FOR MY BROTHER, RODERICK,</span></p>
<p class="ded"><span class="epub-sc">ENGAGED AS LONG IN THE ONE ENDEAVOUR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2f6c19b0